<template>
  <div>
    <div class="w-100" style="margin-top: -85px; position: absolute;">
      <h1 class="text-center" style="color: white">
        Rapport des FNC
        <span class="year-select-wrapper">
    <select
        v-model="current_year"
        @change="fetchData"
        class="year-select-inline"
    >
      <option v-for="year in available_years" :key="year" :value="year">
        {{ year }}
      </option>
    </select>
    <span class="year-select-caret">▾</span>
  </span>
      </h1>
    </div>

    <div class="row mb-4">
      <!-- Carte pour le coût des FNC de l'année précédente -->
      <div class="col-lg-3">
        <div class="card text-center">
          <div class="card-header">
            <h3 class="fs-5 mb-0">Coût des FNC en {{ previous_year }}</h3>
          </div>
          <div class="card-body">
            <animated-number class="font-weight-bold mb-0" style="font-size: 30px" :value="cost_previous_year"></animated-number>
            <span class="ml-2" style="font-size: 30px">€</span>
          </div>
        </div>
      </div>

      <!-- Carte pour le coût des FNC de l'année en cours -->
      <div class="col-lg-3">
        <div class="card text-center">
          <div class="card-header">
            <h3 class="fs-5 mb-0">Coût des FNC en {{ current_year }}</h3>
          </div>
          <div class="card-body">
            <animated-number class="font-weight-bold mb-0" style="font-size: 30px" :value="cost_current_year"></animated-number>
            <span class="ml-2" style="font-size: 30px">€</span>
          </div>
        </div>
      </div>

      <!-- Carte pour le nombre de FNC ouvertes -->
      <div class="col-lg-3">
        <div class="card text-center">
          <div class="card-header">
            <h3 class="fs-5 mb-0">FNC ouvertes</h3>
          </div>
          <div class="card-body">
            <animated-number class="font-weight-bold mb-0" style="font-size: 30px" :value="open_fncs_count"></animated-number>
          </div>
        </div>
      </div>

      <!-- Carte pour le nombre de FNC clôturées -->
      <div class="col-lg-3">
        <div class="card text-center">
          <div class="card-header">
            <h3 class="fs-5 mb-0">FNC clôturées</h3>
          </div>
          <div class="card-body">
            <animated-number class="font-weight-bold mb-0" style="font-size: 30px" :value="closed_fncs_count"></animated-number>
          </div>
        </div>
      </div>

      <!-- Graphique du nombre de FNC par mois -->
      <div class="col-lg-6">
        <div class="row">
          <div class="col">
            <div class="card" style="height: 357px">
              <div class="card-header">
                <h3 class="fs-5 text-center mb-0">Nombre de FNC par mois</h3>
              </div>
              <div class="card-body">
                <BarChart v-if="charts.fnc.data.length > 0" ref="chartReference" :labels="charts.fnc.labels"
                          :data="charts.fnc.data" :color="charts.fnc.color" :key="key"
                          :extraOptions="charts.fnc.chartOptions" :height="300">
                </BarChart>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Liste des FNC ouvertes depuis plus de 6 mois -->
      <div class="col-lg-6">
        <div class="card"  style="height: 357px">
          <div class="card-header">
            <h3 class="fs-5 text-center mb-0"><i class="fas fa-fire mr-3" style="color: red"></i>
              FNC ouvertes depuis plus de 6 mois</h3>
          </div>
          <div class="card-body" style="height: 314px; overflow: auto;">
            <div v-if="open_fncs_over_six_months.length > 0">
              <ul class="list-group">
                <li class="list-group-item" v-for="fnc in open_fncs_over_six_months" :key="fnc.id">
                  <div class="row">
                    <div class="col-lg-6">
                      <strong>Numéro FNC :</strong> {{ fnc.num }}<br>
                      <strong>Date de création :</strong> {{ formatDate(fnc.created_at) }}<br>
                      <strong>Produit :</strong> {{ fnc.product_name }}
                    </div>
                    <div class="col-lg-6">
                      <strong>Contrôlé par :</strong> {{ fnc.controller_name }}<br>
                      <strong>Fournisseur :</strong> {{ fnc.supplier_name }}<br>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
            <div v-else class="h-100 d-flex justify-content-center align-items-center" style="color: lightgrey; font-size: 20px">
              <i class="fas fa-wind mr-2"></i>
              <p class="mb-0">Aucune FNC ouverte depuis plus de 3 mois.</p>
            </div>
          </div>
        </div>
      </div>

      <!-- FNC clôturées par efficacité (cartes filtrables + modal détails) -->
      <div class="col-lg-6">
        <div class="card" style="height: 370px">
          <div class="card-header d-flex align-items-center justify-content-between">
            <h3 class="fs-5 mb-0">Liste des FNC clôturées :</h3>
            <div>
              <select v-model="selected_efficiency" @change="fetchClosedByEfficiency" class="form-control" style="width: auto; min-width: 220px;">
                <option v-for="opt in efficiencyOptions" :key="opt.value + ''" :value="opt.value">
                  {{ opt.label }}
                </option>
              </select>
            </div>
          </div>
          <div class="card-body" style="height: 314px; overflow: auto;">
            <div v-if="filtered_fncs.length > 0" class="fnc-cards">
              <div class="card fnc-item-card mb-2" v-for="fnc in filtered_fncs" :key="fnc.id" @click="openFncDetails(fnc)" style="cursor: pointer; border: 1px solid #e5e5e5">
                <div class="card-body">
                  <div class="d-flex justify-content-between align-items-start">
                    <div class="d-flex justify-content-between align-items-start w-100">
                      <div>
                        <strong>{{ fnc.num }}</strong><br>
                        <small class="text-muted">Clôturée le {{ formatDate(fnc.archived_at) }}</small>
                      </div>
                      <div class="mb-1">
                        <span class="badge badge-pill" :class="badgeClass(fnc.efficiency)">{{ fnc.efficiency && fnc.efficiency !== '' ? fnc.efficiency : 'Non évaluée' }}</span>
                      </div>
                    </div>
                  </div>
                  <div class="row mt-2">
                    <div class="col-4">
                      <span class="text-muted">Produit</span><br>
                      <span>{{ fnc.product_name || '-' }}</span>
                    </div>
                    <div class="col-4">
                      <span class="text-muted">Contrôlé par</span><br>
                      <span>{{ fnc.controller_name || '-' }}</span>
                    </div>
                    <div class="col-4">
                      <span class="text-muted">Fournisseur</span><br>
                      <span>{{ fnc.supplier_name || '-' }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-else class="h-100 d-flex justify-content-center align-items-center" style="color: lightgrey; font-size: 20px">
              <i class="fas fa-wind mr-2"></i>
              <p class="mb-0">Aucune FNC pour ce filtre.</p>
            </div>
          </div>
        </div>
      </div>

      <!-- Répartition des FNC clôturées par efficacité (Pie Chart) -->
      <div class="col-lg-6">
        <div class="card pie-card" style="height: 370px">
          <div class="card-header">
            <h3 class="fs-5 text-center">FNC clôturées par niveau d’efficacité</h3>
          </div>
          <div class="card-body p-0" style="height: 314px; overflow: hidden;">
            <div v-if="hasEfficiencyData()" class="d-flex align-items-stretch h-100 w-100" style="margin-top: -25px">
              <!-- Zone graphique -->
              <div class="pie-chart-col d-flex align-items-center justify-content-center" style="width: 60%">
                <div class="pie-fixed">
                  <PieChart :chart-data="charts.efficiency.chartData" :options="charts.efficiency.options" :height="260" :width="260"/>
                </div>
              </div>

              <!-- Légende externe à droite -->
              <div class="pie-legend-col d-flex flex-column justify-content-center">
                <ul class="pie-legend list-unstyled mb-0">
                  <li v-for="(label, i) in charts.efficiency.chartData.labels" :key="'legend-'+i">
                    <span class="legend-dot" :style="{ backgroundColor: charts.efficiency.chartData.datasets[0].backgroundColor[i] }"></span>
                    <span class="legend-text">
                    {{ label }} — {{ charts.efficiency.chartData.datasets[0].data[i] }} ({{ efficiencyPercent(i) }})
                  </span>
                  </li>
                </ul>
              </div>
            </div>

            <div v-else class="h-100 d-flex justify-content-center align-items-center" style="color: lightgrey; font-size: 20px; width: 100%">
              <i class="fas fa-wind mr-2"></i>
              <p class="mb-0">Aucune données.</p>
            </div>
          </div>
        </div>
      </div>

      <!-- Les 5 produits les plus affectés aux FNC -->
      <div class="col-lg-6">
        <div class="card" style="height: 370px">
          <div class="card-header">
            <h3 class="fs-5 text-center">Les 5 produits les plus affectés aux FNC</h3>
          </div>
          <div class="card-body" style="height: 314px; overflow: auto;">
            <div v-if="top_products.length > 0">
              <div class="card mb-2" style="border: 1px solid lightgrey" v-for="(product, index) in top_products" :key="index">
                <div class="card-body d-flex align-items-center command-item">
                  <i v-if="index === 0" class="fas fa-medal mr-2" style="color: goldenrod"></i>
                  <i v-if="index === 1" class="fas fa-medal mr-2" style="color: silver"></i>
                  <i v-if="index === 2" class="fas fa-medal mr-2" style="color: #a26f21"></i>
                  <div class="d-flex justify-content-between w-100">
                    <p class="mb-0">{{ product.product_name }}</p>
                    <div class="d-flex">
                      <p class="mb-0 mr-5">{{ product.fnc_count }} FNC</p>
                      <p class="mb-0 d-flex justify-content-end" style="width: 100px">{{ product.total_cost ? product.total_cost : '0' }} €</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-else class="h-100 d-flex justify-content-center align-items-center" style="color: lightgrey; font-size: 20px">
              <i class="fas fa-wind mr-2"></i>
              <p class="mb-0">Aucune données.</p>
            </div>
          </div>
        </div>
      </div>

      <!-- Les 5 fournisseurs qui font le plus de FNC -->
      <div class="col-lg-6">
        <div class="card" style="height: 370px">
          <div class="card-header">
            <h3 class="fs-5 text-center">Les 5 Fournisseurs qui font le plus de FNC</h3>
          </div>
          <div class="card-body" style="height: 314px; overflow: auto;">
            <div v-if="top_suppliers.length > 0">
              <div class="card mb-2" style="border: 1px solid lightgrey" v-for="(supplier, index) in top_suppliers" :key="index">
                <div class="card-body d-flex align-items-center command-item">
                  <i v-if="index === 0" class="fas fa-medal mr-2" style="color: goldenrod"></i>
                  <i v-if="index === 1" class="fas fa-medal mr-2" style="color: silver"></i>
                  <i v-if="index === 2" class="fas fa-medal mr-2" style="color: #a26f21"></i>
                  <div class="d-flex justify-content-between w-100">
                    <p class="mb-0">{{ supplier.supplier_name }}</p>
                    <div class="d-flex">
                      <p class="mb-0 mr-5">{{ supplier.fnc_count }} FNC</p>
                      <p class="mb-0 d-flex justify-content-end" style="width: 100px">{{ supplier.total_cost ? supplier.total_cost : '0' }} €</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-else class="h-100 d-flex justify-content-center align-items-center" style="color: lightgrey; font-size: 20px">
              <i class="fas fa-wind mr-2"></i>
              <p class="mb-0">Aucune données.</p>
            </div>
          </div>
        </div>
      </div>

      <!-- Modal détails FNC -->
      <div v-if="showDetailsModal">
        <div class="fnc-modal-backdrop" @click="closeDetailsModal"></div>
        <div class="fnc-modal" role="dialog" aria-modal="true">
          <div class="fnc-modal-header d-flex justify-content-between align-items-center">
            <h5 class="mb-0">{{ selected_fnc ? selected_fnc.num : '' }}</h5>
            <button type="button" class="close" aria-label="Close" @click="closeDetailsModal">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="fnc-modal-body">
            <div v-if="is_details_loading" class="d-flex align-items-center justify-content-center" style="height: 200px;">
              <div class="spinner-border" role="status" aria-hidden="true"></div>
              <span class="sr-only">Chargement…</span>
            </div>
            <div v-else>
              <div class="row">
                <div class="col-md-6">
                  <h6 class="text-muted">Informations générales</h6>
                  <p class="mb-1"><strong>Numéro :</strong> {{ selected_fnc_details && selected_fnc_details.num ? selected_fnc_details.num : (selected_fnc ? selected_fnc.num : '-') }}</p>
                  <p class="mb-1"><strong>État :</strong> Clôturée</p>
                  <p class="mb-1"><strong>Efficacité :</strong> {{ (selected_fnc_details && selected_fnc_details.efficiency) ? selected_fnc_details.efficiency : (selected_fnc && selected_fnc.efficiency ? selected_fnc.efficiency : 'Non évaluée') }}</p>
                  <p class="mb-1"><strong>Créée le :</strong> {{ formatDate(selected_fnc_details && selected_fnc_details.created_at ? selected_fnc_details.created_at : null) }}</p>
                  <p class="mb-1"><strong>Clôturée le :</strong> {{ formatDate(selected_fnc_details && selected_fnc_details.archived_at ? selected_fnc_details.archived_at : (selected_fnc ? selected_fnc.archived_at : null)) }}</p>
                </div>
                <div class="col-md-6">
                  <h6 class="text-muted">Acteurs & Références</h6>
                  <p class="mb-1"><strong>Produit :</strong> {{ pick(selected_fnc_details,'product.name') || selected_fnc.product_name || '-' }}</p>
                  <p class="mb-1"><strong>Fournisseur :</strong> {{ pick(selected_fnc_details,'supplier.name') || selected_fnc.supplier_name || '-' }}</p>
                  <p class="mb-1"><strong>Contrôlé par :</strong> {{ pick(selected_fnc_details,'controller.name') || selected_fnc.controller_name || '-' }}</p>
                  <p class="mb-1"><strong>Coût :</strong> {{ selected_fnc_details && selected_fnc_details.cost ? selected_fnc_details.cost : '-' }} €</p>
                </div>
              </div>

              <hr>

              <div class="row">
                <div class="col-md-6">
                  <h6 class="text-muted">Description</h6>
                  <p class="mb-2" style="white-space: pre-wrap;">{{ selected_fnc_details && selected_fnc_details.description ? selected_fnc_details.description : '-' }}</p>
                  <h6 class="text-muted">Constat</h6>
                  <p class="mb-2" style="white-space: pre-wrap;">{{ selected_fnc_details && selected_fnc_details.cause ? selected_fnc_details.cause : '-' }}</p>
                </div>
                <div class="col-md-6">
                  <h6 class="text-muted">Actions</h6>
                  <p class="mb-2"><strong>Corrective :</strong><br><span style="white-space: pre-wrap;">{{ selected_fnc_details && selected_fnc_details.corrective_action ? selected_fnc_details.corrective_action : '-' }}</span></p>
                  <p class="mb-2"><strong>Currative :</strong><br><span style="white-space: pre-wrap;">{{ selected_fnc_details && selected_fnc_details.currative_action ? selected_fnc_details.currative_action : '-' }}</span></p>
                </div>
              </div>

              <div v-if="selected_fnc_details && selected_fnc_details.attachments && selected_fnc_details.attachments.length">
                <hr>
                <h6 class="text-muted">Pièces jointes</h6>
                <ul class="mb-0">
                  <li v-for="(file, idx) in selected_fnc_details.attachments" :key="'att-'+idx">
                    <a :href="file.url" target="_blank" rel="noopener">{{ file.name || ('Fichier ' + (idx+1)) }}</a>
                  </li>
                </ul>
              </div>

            </div>
          </div>
          <div class="fnc-modal-footer d-flex justify-content-end">
            <button type="button" class="btn btn-secondary" @click="closeDetailsModal">Fermer</button>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>


<script>
import { AnimatedNumber } from "src/components";
import moment from "moment";
import BarChart from "src/components/Charts/BarChart";
import { Pie, mixins } from "vue-chartjs";

import Chart from 'chart.js';
const PercentLabelPlugin = {
  id: 'percent-labels',
  afterDatasetsDraw(chart) {
    const opts = chart.config.options || {};
    if (!opts.drawPercentages) return;

    const type = chart.config.type;
    if (type !== 'pie' && type !== 'doughnut') return;

    const ds = chart.data.datasets && chart.data.datasets[0];
    if (!ds) return;

    const data = ds.data || [];
    const total = data.reduce((a, b) => a + ((+b) || 0), 0);
    if (!total) return;

    const ctx = chart.ctx;
    const fontStr = (opts.percentageFont || 'bold 12px sans-serif');
    const minPct = (opts.minLabelPercent != null ? opts.minLabelPercent : 10); // ← seuil %

    ctx.save();
    ctx.fillStyle = '#fff';
    ctx.font = fontStr;
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';

    const fontSize = parseInt((fontStr.match(/(\d+)px/) || [,'12'])[1], 10);

    const meta = chart.getDatasetMeta(0);
    meta.data.forEach((arc, i) => {
      const v = +data[i] || 0;
      if (!v) return;

      const pctNum = (v / total) * 100;
      if (pctNum < minPct) return; // ← filtre < 10%

      const text = pctNum.toFixed(1) + '%';
      const model = arc._model || arc._view;
      const angle = model.endAngle - model.startAngle;
      const midRadius = (model.innerRadius + model.outerRadius) / 2;

      const textW = ctx.measureText(text).width;
      const arcLen = midRadius * angle;
      const thickness = model.outerRadius - model.innerRadius;
      const margin = 6;

      if (arcLen < textW + margin) return;
      if (thickness < fontSize + 4) return;

      const a = (model.startAngle + model.endAngle) / 2;
      const x = model.x + midRadius * Math.cos(a);
      const y = model.y + midRadius * Math.sin(a);

      // Petite ombre pour lisibilité
      ctx.save();
      ctx.shadowColor = 'rgba(0,0,0,.25)';
      ctx.shadowBlur = 2;
      ctx.fillText(text, x, y);
      ctx.restore();
    });

    ctx.restore();
  }
};
Chart.plugins.register(PercentLabelPlugin);


const { reactiveProp } = mixins;

const PieChart = {
  extends: Pie,
  mixins: [reactiveProp],
  props: {
    chartData: { type: Object, required: true },
    options: { type: Object, default: () => ({}) },
    height: { type: Number, default: 280 },
    width:  { type: Number, default: 280 }
  },
  mounted() {
    this.renderChart(this.chartData, this.options);
  },
  watch: {
    chartData() {
      this.renderChart(this.chartData, this.options);
    },
    options: {
      deep: true,
      handler() {
        this.renderChart(this.chartData, this.options);
      }
    }
  }
};

export default {
  components: {
    AnimatedNumber,
    BarChart,
    PieChart,
  },
  data() {
    const currentYear = new Date().getFullYear();
    return {
      current_year: currentYear,
      previous_year: currentYear - 1,
      available_years: Array.from({length: 6}, (_, i) => currentYear - i), // 6 dernières années
      cost_previous_year: 0,
      cost_current_year: 0,
      open_fncs_count: 0,
      closed_fncs_count: 0,
      top_products: [],
      top_suppliers: [],
      open_fncs_over_six_months: [],
      key: 0,
      fncList: [],
      // Filtres et données pour la liste par efficacité
      efficiencyOptions: [
        {label: 'Efficace', value: 'Efficace'},
        {label: 'Partiellement efficace', value: 'Partiellement Efficace'},
        {label: 'Non Efficace', value: 'Non Efficacce'},
        {label: 'Non évaluée', value: 'Non évaluée'},
      ],
      selected_efficiency: 'Efficace',
      filtered_fncs: [],
      // Modal détails
      showDetailsModal: false,
      is_details_loading: false,
      selected_fnc: null,
      selected_fnc_details: null,
      charts: {
        fnc: {
          labels: [
            "Janvier", "Février", "Mars", "Avril", "Mai", "Juin",
            "Juillet", "Août", "Septembre", "Octobre", "Novembre", "Décembre",
          ],
          data: [],
          color: "#f96332",
          chartOptions: {
            scales: {
              xAxes: [{display: true}],
              yAxes: [{
                display: true,
                ticks: {min: 0, suggestedMax: 10, stepSize: 1},
              }],
            },
          }
        },
        efficiency: {
          labels: [],
          counts: [],
          colors: ["#2ecc71", "#f1c40f", "#e74c3c", "#95a5a6", "#3498db", "#9b59b6"],
          chartData: null,
          options: {
            responsive: false,
            maintainAspectRatio: false,
            legend: {
              display: false,
            },
            layout: {padding: 0},
            tooltips: {
              callbacks: {
                label(tooltipItem, data) {
                  const ds = data.datasets[tooltipItem.datasetIndex];
                  const value = ds.data[tooltipItem.index] || 0;
                  const total = ds.data.reduce((a, b) => a + (b || 0), 0);
                  const pct = total ? ((value / total) * 100).toFixed(1) : "0.0";
                  const label = data.labels[tooltipItem.index] || "";
                  return `${label}: ${value} (${pct}%)`;
                }
              }
            },
            drawPercentages: true,
            percentageFont: 'bold 16px sans-serif',
            minLabelPercent: 10
          }
        }
      },
    };
  },
  mounted() {
    this.fetchData();
    // Fermer la modale avec Echap
    window.addEventListener('keydown', this.onKeyDown);
  },
  beforeDestroy() {
    window.removeEventListener('keydown', this.onKeyDown);
  },
  methods: {
    onKeyDown(e) {
      if (e.key === 'Escape' && this.showDetailsModal) this.closeDetailsModal();
    },
    fetchData() {
      this.previous_year = this.current_year - 1;

      // Récupération du graphique FNC par mois
      this.axios.get(process.env.VUE_APP_API_BASE_URL + `fnc/month`, {
        params: {year: this.current_year}
      }).then((response) => {
        this.fncList = response.data;
        this.charts.fnc.data = Object.values(this.fncList);
        if (this.$refs.chartReference) {
          this.$refs.chartReference.updated();
        }
        this.key++;
      });

      // Récupération du rapport FNC
      this.axios.get(process.env.VUE_APP_API_BASE_URL + `fnc/reports`, {
        params: {year: this.current_year},
      }).then((response) => {
        this.cost_previous_year = response.data.cost_previous_year;
        this.cost_current_year = response.data.cost_current_year;
        this.open_fncs_count = response.data.open_fncs_count;
        this.closed_fncs_count = response.data.closed_fncs_count;
        this.top_products = response.data.top_products;
        this.top_suppliers = response.data.top_suppliers;
        this.open_fncs_over_six_months = response.data.open_fncs_over_six_months;
      });

      // Répartition des FNC clôturées par niveau d'efficacité (attend un payload { labels:[], data:[] })
      this.axios.get(process.env.VUE_APP_API_BASE_URL + `fnc/closed-efficiency`, {
        params: {year: this.current_year}
      }).then((response) => {
        const labels = response.data.labels || ["Efficace", "Partiellement efficace", "Inefficace", "Non évaluée"];
        const counts = response.data.data || [];
        this.charts.efficiency.labels = labels;
        this.charts.efficiency.counts = counts;
        this.buildEfficiencyChart();
      }).catch(() => {
        // fallback vide si l'endpoint n'est pas encore prêt
        this.charts.efficiency.labels = ["Efficace", "Partiellement efficace", "Inefficace", "Non évaluée"];
        this.charts.efficiency.counts = [];
        this.buildEfficiencyChart();
      });

      // Liste des FNC clôturées selon efficacité (par défaut "Efficace")
      this.fetchClosedByEfficiency();
    },
    fetchClosedByEfficiency() {
      var eff = this.selected_efficiency; // valeur brute envoyée à l'API ('' pour Non évaluée)
      this.axios.get(process.env.VUE_APP_API_BASE_URL + `fnc/closed`, {
        params: {year: this.current_year, efficiency: eff}
      }).then((response) => {
        this.filtered_fncs = Array.isArray(response.data) ? response.data : (response.data.items || []);
      }).catch(() => {
        this.filtered_fncs = [];
      });
    },
    openFncDetails(fnc) {
      this.selected_fnc = fnc;
      this.selected_fnc_details = null;
      this.is_details_loading = true;
      this.showDetailsModal = true;

      // Récupère toutes les infos liées à la FNC (adapter l'endpoint si différent)
      this.axios.get(process.env.VUE_APP_API_BASE_URL + `fnc/` + fnc.id)
          .then((res) => {
            this.selected_fnc_details = res.data;
          })
          .catch(() => {
            this.selected_fnc_details = null;
          })
          .then(() => {
            this.is_details_loading = false;
          });
    },
    closeDetailsModal() {
      this.showDetailsModal = false;
      this.selected_fnc = null;
      this.selected_fnc_details = null;
    },
    buildEfficiencyChart() {
      const labels = this.charts.efficiency.labels;
      const counts = this.charts.efficiency.counts;
      const colors = this.charts.efficiency.colors.slice(0, labels.length);
      this.charts.efficiency.chartData = {
        labels: labels,
        datasets: [
          {
            data: counts,
            backgroundColor: colors,
            borderColor: "#ffffff",
            borderWidth: 1
          }
        ]
      };
    },
    hasEfficiencyData() {
      var cd = this.charts && this.charts.efficiency && this.charts.efficiency.chartData;
      var ds = cd && cd.datasets && cd.datasets[0] && cd.datasets[0].data ? cd.datasets[0].data : [];
      var total = ds.reduce(function (a, b) {
        return a + ((+b) || 0);
      }, 0);
      return total > 0;
    },
    efficiencyPercent(i) {
      var cd = this.charts && this.charts.efficiency && this.charts.efficiency.chartData;
      var ds = cd && cd.datasets && cd.datasets[0] && cd.datasets[0].data ? cd.datasets[0].data : [];
      var total = ds.reduce(function (a, b) {
        return a + ((+b) || 0);
      }, 0);
      var value = ds[i] ? (+ds[i] || 0) : 0;
      if (!total) return '0.0%';
      return ((value / total) * 100).toFixed(1) + '%';
    },
    // Helpers
    formatDate(dateString) {
      if (!dateString) return '-';
      return moment(dateString).format('DD/MM/YYYY');
    },
    pick(obj, path) {
      if (!obj || !path) return null;
      var parts = path.split('.');
      var cur = obj;
      for (var i = 0; i < parts.length; i++) {
        if (cur && typeof cur === 'object' && parts[i] in cur) {
          cur = cur[parts[i]];
        } else {
          return null;
        }
      }
      return cur;
    },
    badgeClass(eff) {
      var v = eff || '';
      if (v === 'Efficace') return 'badge-success';
      if (v === 'Partiellement Efficace') return 'badge-warning';
      if (v === 'Non Efficacce') return 'badge-danger';
      return 'badge-secondary';
    }
  },
  watch: {
    selected_efficiency() {
      this.fetchClosedByEfficiency();
    }
  }
};
</script>

<style>

.pie-card .pie-legend-col {
  width: 40%;
  min-width: 260px; /* évite le texte coupé */
  max-height: 100%;
  padding: 12px 12px 12px 8px;
  box-sizing: border-box;
}

/* Liste + items : pas de troncature, wrap normal */
.pie-card .pie-legend {
  overflow: auto; /* scroll si trop d'items */
}

.pie-card .pie-legend li {
  display: flex;
  align-items: center;
  margin-bottom: 8px;
}

.pie-card .legend-dot {
  width: 12px;
  height: 12px;
  border-radius: 2px;
  margin-right: 8px;
  flex: 0 0 12px;
}

.pie-card .legend-text {
  white-space: normal; /* autorise le retour à la ligne */
  word-break: break-word; /* coupe proprement si nécessaire */
  overflow: visible;
  text-overflow: clip; /* pas d’ellipses */
}

/* Responsive : passer la légende en dessous sur petits écrans */
@media (max-width: 991.98px) {
  .pie-card .pie-chart-col {
    flex-basis: 100%;
  }

  .pie-card .pie-legend-col {
    width: 100%;
    min-width: 0;
    padding-top: 0;
    justify-content: flex-start;
  }
}

/* Boîte carrée fixe pour le pie */
.pie-fixed {
  width: 260px;
  height: 260px;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* S’assurer que le canvas respecte la taille fixe */
.pie-card .pie-fixed canvas {
  width: 260px !important;
  height: 260px !important;
}

/* Cartes FNC list */
.fnc-cards .fnc-item-card:hover {
  box-shadow: 0 6px 12px rgba(0, 0, 0, .08);
  transform: translateY(-1px);
  transition: all .15s ease-in-out;
}

/* Modale légère sans Bootstrap JS */
.fnc-modal-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, .45);
  z-index: 1040;
}

.fnc-modal {
  position: fixed;
  z-index: 1050;
  top: 50%;
  left: 50%;
  width: 880px;
  max-width: calc(100vw - 32px);
  max-height: calc(100vh - 32px);
  transform: translate(-50%, -50%);
  background: #fff;
  border-radius: .5rem;
  box-shadow: 0 10px 30px rgba(0, 0, 0, .25);
  display: flex;
  flex-direction: column;
}

.fnc-modal-header, .fnc-modal-footer {
  padding: .75rem 1rem;
  border-bottom: 1px solid #eee;
}

.fnc-modal-footer {
  border-top: 1px solid #eee;
  border-bottom: none;
}

.fnc-modal-body {
  padding: 1rem;
  overflow: auto;
}

/* Year select existing styles */
.year-select-wrapper {
  position: relative;
  display: inline-flex;
  align-items: center;
  margin-left: .5rem;
}

/* On garde un select déguisé mais avec une vraie surface cliquable */
.year-select-inline {
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  background: transparent;
  border: none;
  color: #fff;
  font: inherit;
  font-weight: 700;
  line-height: 1.2;
  padding: .2rem 1.6rem .2rem .4rem; /* plus d'espace autour pour cliquer */
  min-width: 5.5ch; /* largeur minimum pour 2025 */
  text-align: center;
  border-radius: 4px;
  cursor: pointer;
}

/* Sur hover/focus : feedback visuel clair */
.year-select-inline:hover,
.year-select-inline:focus {
  background: rgba(255, 255, 255, 0.1);
  outline: none;
}

/* Icône caret custom, bien alignée */
.year-select-caret {
  position: absolute;
  right: .4rem;
  pointer-events: none;
  color: #fff;
  font-weight: 700;
  font-size: .8em;
}

/* Forcer la lisibilité des options quand la liste est ouverte */
.year-select-inline option {
  background: #fff;
  color: #000;
}


.fs-5 {
  font-size: 1.25rem;
}

.default-datagrid .e-pager .e-currentitem,
.e-pager .e-currentitem:hover {
  background: #f96332;
  color: #fff;
  opacity: 1;
}

.separator {
  position: absolute;
  top: 0;
  right: 0;
  width: 1px;
  height: 100%;
  background-color: #e0e0e0;
}

.col:not(:last-child) .separator {
  display: block;
}

.col:last-child .separator {
  display: none;
}
</style>
